import React, { useState, useEffect } from "react"
import { motion } from "framer-motion"
import SignupForm from "../../components/auth/signup/SignupForm"
import VerifyEmail from "../../components/auth/signup/VerifyEmail"
import VerifySuccess from "../../components/auth/signup/VerifySuccess"
import Navbar from "../../components/auth/common/Navbar"
import image from "../../assets/login.jpg"
import { useNavigate } from "react-router-dom"

const Signup = () => {
  const navigate = useNavigate()
  const [step, setStep] = useState(1)
  const [tempToken, setTempToken] = useState()
  const [isSmallScreen, setIsSmallScreen] = useState(false)

  useEffect(() => {
    const userData = localStorage.getItem("user");
    const parsedUser = JSON.parse(userData);
    // console.log(parsedUser)
    if (parsedUser) {
        if (parsedUser.role === "admin") navigate("/admin")
        if (parsedUser.role === "client") navigate("/client")
        if (parsedUser.role === "agent") navigate("/agent")
        if (parsedUser.role === "sub-admin") navigate("/agent")
    }
}, [])

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1020)
    }

    handleResize()
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className={`flex items-center justify-center min-h-screen select-none ${
        isSmallScreen ? "bg-cover bg-center" : "bg-white"
      } lg:pt-[100px] pb-[40px]`}
      style={{ backgroundImage: isSmallScreen ? `url(${image})` : "none" }}
    >
      <Navbar />
      {step === 1 && <SignupForm setStep={setStep} setTempToken={setTempToken} />}
      {step === 2 && <VerifyEmail setStep={setStep} tempToken={tempToken} />}
      {step === 3 && <VerifySuccess setStep={setStep} />}
    </motion.div>
  )
}

export default Signup

